jQuery('.meei_tweets').on('DOMSubtreeModified propertychange',"#twitter-widget-0", function() {
	var timelineContents = jQuery(".twitter-timeline").contents();
	// .timeline-Tweet-actions
	jQuery(timelineContents).find(".timeline-Tweet-media, .TweetAuthor-avatar, .TweetAuthor-verifiedBadge, .timeline-Header, .timeline-Footer, .timeline-Tweet-brand, .TweetAuthor-name").css("display", "none");
	jQuery(timelineContents).find(".TweetAuthor-screenName").css({
		"color":"#D0021B",
		"font-size":"16px",
		"font-weight":"bold"
	});  
	jQuery(timelineContents).find(".timeline-Body").css("border","none");
	var screenName = jQuery(".twitter-timeline").contents().find(".TweetAuthor-screenName");
	jQuery(screenName).css({
		"padding-left":"30px",
		"line-height":"30px",
		"margin-bottom":"15px",
		"display":"block",
		"background":"url('/public/assets/MEEI/svg/theme/icon-tweet-red.svg') no-repeat top left"
	});
	
	jQuery(timelineContents).find(".timeline-Tweet-text, .timeline-Tweet-actions").css({
		"margin-left":"0",
		"margin-right":"0"
	});
	jQuery(timelineContents).find(".timeline-Tweet-author").css({
		"padding-left":"0"
	});
	
	jQuery(timelineContents).find(".timeline-Tweet").css({
		"background":"transparent",
		"padding":"0"
	});	
	
	jQuery(timelineContents).find(".timeline-Tweet a").mouseenter(function() {
	    $(this).css({
			"text-decoration":"underline"
		});
	}).mouseleave(function() {
	    $(this).css({
			"text-decoration":"none"
		});
	});
	  
	jQuery(timelineContents).find(".timeline-Tweet-text").css({
		"color":"#636363",
	    "font-size": "1.5rem",
	    "line-height": "2.25rem",
	    "font-weight": "100"
	});
	jQuery(timelineContents).find(".timeline-Tweet-text a, .TweetAuthor-link").css({
		"color":"#D0021B",
		"font-weight":"bold"
	});
	var postedOn = jQuery(timelineContents).find(".dt-updated").attr("aria-label");
	jQuery(timelineContents).find(".dt-updated").html(postedOn).css("color","#636363");
  
	jQuery(".meei_tweets").css("height", "100%");


	jQuery(timelineContents).find(".timeline-Tweet-action .Icon--share").css("background-image","url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20class%3D%22icon%22%20fill%3D%22%23667580%22%20d%3D%22M21.78%2011.47l-5.14-5.14c-.292-.292-.767-.292-1.06%200s-.293.77%200%201.062l3.858%203.858H8.918c-.415%200-.75.336-.75.75s.335.75.75.75h10.52l-3.857%203.858c-.29.293-.29.768%200%201.06.148.147.34.22.53.22s.386-.072.53-.22l5.14-5.138c.294-.293.294-.767%200-1.06z%22%2F%3E%3Cpath%20class%3D%22icon%22%20fill%3D%22%23667580%22%20d%3D%22M9.944%2020.5H4.292c-.437%200-.792-.355-.792-.792V4.292c0-.437.355-.792.792-.792h5.652c.414%200%20.75-.336.75-.75S10.358%202%209.944%202H4.292C3.028%202%202%203.028%202%204.292v15.416C2%2020.972%203.028%2022%204.292%2022h5.652c.414%200%20.75-.336.75-.75s-.336-.75-.75-.75z%22%2F%3E%3C%2Fsvg%3E)");
	jQuery(timelineContents).find(".timeline-Tweet-action .Icon--heart").css("background-image","url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20class%3D%22icon%22%20fill%3D%22%23667580%22%20d%3D%22M12%2021.638h-.014C9.403%2021.59%201.95%2014.856%201.95%208.478c0-3.064%202.525-5.754%205.403-5.754%202.29%200%203.83%201.58%204.646%202.73.813-1.148%202.353-2.73%204.644-2.73%202.88%200%205.404%202.69%205.404%205.755%200%206.375-7.454%2013.11-10.037%2013.156H12zM7.354%204.225c-2.08%200-3.903%201.988-3.903%204.255%200%205.74%207.035%2011.596%208.55%2011.658%201.52-.062%208.55-5.917%208.55-11.658%200-2.267-1.822-4.255-3.902-4.255-2.528%200-3.94%202.936-3.952%202.965-.23.562-1.156.562-1.387%200-.015-.03-1.426-2.965-3.955-2.965z%22%2F%3E%3C%2Fsvg%3E)");


});
